var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/anze-product.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [
                    _vm._v("泰康"),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("1-5类"),
                    ]),
                    _vm._v("雇主险"),
                  ]),
                  _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v("1-5类职业 | 行业超低价 | 全线上操作"),
                  ]),
                  _c("p", [
                    _vm._v("① 1-5类职业，16-65岁可投保，3人起保"),
                    _c("br"),
                    _vm._v("② 线上保全，次日生效"),
                    _c("br"),
                    _vm._v("③ 多种方案，自由组合"),
                    _c("br"),
                    _vm._v("④ 保额最高100万，伤残比例可选"),
                    _c("br"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保\n        ")]
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "25px" },
                      attrs: {
                        loading: _vm.isDownLoading,
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("下载泰康险职业类别表\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c("avue-crud", {
                    ref: "plan",
                    attrs: {
                      "cell-style": _vm.onCellStyle,
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "短期方案(短期费率系数)" } },
                [
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: { data: _vm.dataDq, option: _vm.optionDq },
                    },
                    [_c("template", { slot: "header" })],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [_vm._v("Q")]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(qa.question))]
                              ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "20px",
                                    "background-color": "MediumSeaGreen",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [_vm._v("A")]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "white-space": "pre-wrap" } },
                                [_vm._v(_vm._s(qa.answer))]
                              ),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("h3", [_vm._v("保险条款及须知")]),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "line-height": "32px",
                            "white-space": "pre-line",
                          },
                        },
                        [
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("1、投保地区"),
                          ]),
                          _vm._v(
                            "\n            本产品仅限在中国大陆注册的合法机构购买，"
                          ),
                          _c("span", { staticClass: "u-font-weight-bold" }, [
                            _vm._v(
                              "实际注册或经营地址在以下地区的单位本产品不予承保"
                            ),
                          ]),
                          _vm._v(
                            "：天津市，山东省招远市、禹城市、荣成市、德州市、临沂市，北京平谷区、怀柔区、密云区，河北省三河市、廊坊市、沧州市、秦皇岛市、青龙县，黑龙江省，辽宁省，吉林省，内蒙古自治区通辽市、赤峰市，河南信阳市，湖北省黄冈市、麻城市，江苏省常州市。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("2、生效时间"),
                          ]),
                          _vm._v(
                            "\n            线上投保成功后，最早T+2生效。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("3、保单保全"),
                          ]),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "已发生理赔的人员不可以被替换和批减。线上保全次日生效。"
                            ),
                          ]),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("4、年龄结构"),
                          ]),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "本产品3人起保，投保年龄：16-65周岁身体健康、能正常工作或正常生活的自然人。如无法证明合法劳动或雇佣关系，本保单不承担赔偿责任；"
                            ),
                          ]),
                          _vm._v(
                            "61（含）-65周岁（含）雇员占比不得超过总投保人数的10%，若雇员年龄超过60岁（含），各项责任限额为50%。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("5、行业限制"),
                          ]),
                          _vm._v(
                            "\n            本产品仅承保1-5类职业类别雇员，职业分类表以我司为准，具体可承保职业以保险公司核保结果为准。\n            5类职业雇员每人伤亡责任限额最高可投50万。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("6、承保公司及适用条款"),
                          ]),
                          _vm._v(
                            "\n            本产品由泰康在线财产保险股份有限公司承保，泰康在线财产保险股份有限公司为在线经营的互联网保险公司，无线下分支机构，各项保险服务流程均可线上操作，不影响您的理赔，但在您所在的地区，可能无法直接提供及时的面对面线下服务。\n            本产品适用条款如下:\n            "
                          ),
                          _c(
                            "table",
                            {
                              staticStyle: { margin: "15px" },
                              attrs: {
                                border: "1",
                                cellpadding: "0",
                                ellspacing: "0",
                              },
                            },
                            [
                              _c("tr", [
                                _c("th", { staticStyle: { width: "50%" } }, [
                                  _vm._v("备案名称"),
                                ]),
                                _c("th", { staticStyle: { width: "50%" } }, [
                                  _vm._v("备案编号"),
                                ]),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _vm._v(
                                      "《泰康在线财产保险股份有限公司雇主责任保险（C款）》"
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v("C00019930912022120268661")]
                                ),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _vm._v(
                                      "《泰康在线财产保险股份有限公司附加24小时人身意外伤害扩展保险》"
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v("C00019930922021063099022")]
                                ),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _vm._v(
                                      "《泰康在线财产保险股份有限公司附加行业十级伤残鉴定标准保险》"
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v("C00019930922019062517642")]
                                ),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _vm._v(
                                      "《泰康在线财产保险股份有限公司雇主责任保险附加每日住院津贴保险（互联网专属）》"
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v("C00019932522021122225403")]
                                ),
                              ]),
                              _c("tr", [
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _vm._v(
                                      "《泰康在线财产保险股份有限公司附加伤残赔偿比例调整保险（B款）》"
                                    ),
                                  ]
                                ),
                                _c(
                                  "td",
                                  { staticStyle: { "text-align": "center" } },
                                  [_vm._v("C00019930922021092202223")]
                                ),
                              ]),
                            ]
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("7、保单形式"),
                          ]),
                          _vm._v(
                            "\n            网上投保为您提供电子保单，根据《中华人民共和国民法典》第四百六十九条规定，数据电文是合法的合同表现形式，电子保单与纸质保单具有同等法律效力。您可以登录www.tk.cn自助查询对电子保单的真实性进行验证。产品保险合同将以电子保单和电子普通发票的形式提供，专票出具后进行邮寄。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("8、如实告知"),
                          ]),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "您应如实填写投保信息，并就保险公司提出的询问据实告知,否则保险公司有权根据《中华人民共和国保险法》第十六条的规定解除保险合同且不承担赔偿责任：\n            （1）订立保险合同时，保险公司就保险标的或者被保险人的有关情况提出询问的，投保人应当如实告知。\n            （2）投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同。\n            （3）投保人故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。\n            （4）投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，但退还保险费。"
                            ),
                          ]),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("9、相关授权"),
                          ]),
                          _vm._v(
                            "\n            如您投保此保险，视为您本人授权泰康在线出于提升保险服务质量之目的，合法的从任何单位、组织和个人获取您有关的资料和证明，作为审核投保、处理理赔及提供与本保险有关其他服务的依据。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("10、信息变更"),
                          ]),
                          _vm._v(
                            "\n            如果您的邮件地址、通信地址、邮编、联系电话发生变化，请与本公司客户服务电话95522-3联系，办理变更事宜。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("11、偿付能力信息披露"),
                          ]),
                          _vm._v(
                            "\n            保险公司最新季度综合偿付能力充足率、风险综合评级评价结果等信息，请登录保险公司偿付能力信息披露页面http://channel.tk.cn/page/notice/index.html进行查询。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("12、增值税告知"),
                          ]),
                          _vm._v(
                            "\n            本保险产品您所缴纳的保费为含税保费，其中包含6%增值税。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("13、反洗钱告知"),
                          ]),
                          _vm._v(
                            "\n            本保险产品保费超过人民币20万元时，需提供单位负责人身份证明。\n            1）企业营业执照；\n            2）法人身份证正反面照片；\n            3）负责人身份证正反面照片；\n            4）经办人身份证正反面照片；\n            5）受益人身份证正反面照片；\n            6）泰康在线非自然人客户受益所有人信息采集表。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("14、信息安全"),
                          ]),
                          _vm._v(
                            "\n            泰康在线严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，保护您提供的个人信息、数据和隐私不受到非法的泄露或披露给未获授权的第三方。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("15、投诉渠道"),
                          ]),
                          _vm._v(
                            "\n            您在购买产品过程中，如发现泰康在线有关人员有违法、违规行为，或认为自身权益受到侵犯，请您保留相关证据并向泰康在线投诉，投诉电话：95522-3。\n            "
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("16、争议处理"),
                          ]),
                          _vm._v(
                            "\n            因履行本合同发生的争议，由当事人协商解决，协商不成的，提交武汉仲裁委员会仲裁。\n          "
                          ),
                        ]
                      ),
                      _c("el-divider"),
                      _c("h3", [_vm._v("特别约定 ")]),
                      _c("span", { staticClass: "red-bold" }),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "line-height": "32px",
                            "white-space": "pre-line",
                          },
                        },
                        [
                          _vm._v("1、"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "本产品仅限在中国大陆注册的合法机构购买，实际注册或经营地址在以下地区的单位本产品不予承保："
                            ),
                          ]),
                          _vm._v(
                            "天津市，山东省招远市、禹城市、荣成市、德州市、临沂市，北京平谷区、怀柔区、密云区，河北省三河市、廊坊市、沧州市、秦皇岛市、青龙县，黑龙江省，辽宁省，吉林省，内蒙古自治区通辽市、赤峰市，河南信阳市，湖北省黄冈市、麻城市，江苏省常州市。\n            2、投保人及被保人名称中含有以下所列关键词的:钢铁、建筑、钢丝绳、钢绳、危险品、渔业、爆破、幕墙、脚手架、建设、石材、拆、矿业、采石、劳联、产联、疏浚、铁塔、电梯、造船、船舶维修、船舶修造、船舶工程、船务、重工，保险公司不予承保。\n            3、本方案3人起保，承保雇员需为16周岁（含）-65周岁（含）身体健康、能正常工作或正常生活的自然人，雇员需提供清单记名投保，61（含）-65周岁（含）雇员占比不得超过总投保人数的10%，若雇员年龄超过60岁（含），各项责任限额为50%。\n            4、本保险所指的雇员，包括但不限于被保险人的长期雇佣人员、临时雇佣人员、个体工商户的负责人、法人代表或个体工商户营业执照上列明的经营者等与被保险人存在实际雇佣关系的工作人员。\n            5、被保险雇员必须与被保险人存在实际雇佣关系，否则，保险公司有权拒绝赔偿。\n            6、同一保险期间内，同一雇员只允许购买一份保单。\n            7、本保险承保雇员的职业范围：《职业分类表》中的1-5级职业等级（标注拒保的除外）；雇员是否涉高以保单中雇员清单信息约定为准，如保单中约定雇员不涉高，出险时雇员从事高处作业，保险人不承担赔偿责任。高处作业以《高处作业分级标准》(中华人民共和国国家标准GB3608-2008)中的定义为准(在距坠落高度基准面2m或2m以上有可能坠落的高处进行作业)。若不属于本保险承保雇员的职业范围请勿投保；"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "如出险时被保险人的雇员工作类型所对应的职业属于本产品拒保职业的，保险人不承担赔偿责任，拒保职业清单详见保单。"
                            ),
                          ]),
                          _vm._v(
                            "\n            8、本保险医疗费用每次免赔200元，赔付比例100%。\n            9、经医院证明，误工费每次事故免赔3天，赔偿公式为：每日赔偿限额（每日赔偿限额在保单中约定）×(实际暂时丧失工作能力天数-3天)，每次不超过90天，累计不超过180天，该雇员在评定伤残等级后，本项赔偿责任终止。\n            10、兹经合同双方同意，被保险人必须在知道或应当知道保险事故发生后的48小时内（或保单约定的时间内）向保险人报案，因延迟报案影响保险人查勘、定损的，保险人对于无法核实的部分不承担赔偿责任。对身故、伤残案件，能核实事故真实情况，但报案超过案发时间72小时（含）以上的，按损失金额的50%免赔后进行赔付；对非身故、伤残的其他案件，能核实事故真实情况，但报案超过案发时间1个月以上（含1个月）的，按损失金额的50%免赔后进行赔付。本特别约定与主险条款内容相悖之处，以本特别约定为准；未尽之处，以主险条款为准。\n            11、本保险项下，医疗费用的赔付范畴依据被保险人所在省份的基本医疗保险的相关药品目录及诊疗项目目录及其相应比例执行。除紧急抢救外，被保险人均应在二级以上（含二级）医院或保险人认可的医疗机构就诊。未在保险人认可的医疗机构就诊的，保险人有权拒绝赔付。北京平谷区、密云区，河北省廊坊市、青龙县、三河市，天津滨海区、静海区，辽宁铁岭市，山东禹城市、招远市、荣成市，河南信阳市下辖的各医疗机构，不在保险公司认可医院范围内，即上述地区医疗机构的医疗发票、伤残鉴定报告、死亡事故说明等均不属于保险公司理赔范畴，且不承担任何保单责任。\n            12、本保单承保被保险人雇员在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡（既往症原因除外），本保单项下雇员赔偿限额不超过30万。既往症原因导致的猝死不属于本保单赔偿范围。既往症指如下情况：被保险人的雇员患有恶性肿瘤、心脏病（心功能不全II级及II级以上）、心肌梗塞、白血病、高血压病（2级以上）、肝硬化、慢性阻塞性肺疾病、脑血管疾病、慢性肾脏疾病、糖尿病、再生障碍性贫血、先天性畸形、变形和染色体异常、精神和行为障碍（依照世界卫生组织《疾病和有关健康问题的国际统计分类（ICD-10）》确定）、《中华人民共和国传染病防治法》规定的甲类及乙类传染病(含艾滋病)、癫痫病及正患病住院及全休、半休状态。\n            13、本产品承保的雇员因交通事故发生的死亡、伤残、医疗案件，对出险的雇员属于工伤保险认定范围内的交通事故进行赔偿。\n            14、本产品承保雇员以附件上传名单为准，若本保单被保险人雇员实际职业类别高于保单人员清单列明职业类别的，保险人退还保险费，不承担保险责任。\n            15、从事5类及以上特种作业岗位和高空岗位，按照国家规定须具有特种作业证和高空作业证，出险时如未能提供特种作业证和高空作业证，免赔率为80%。\n            16、本保单可以增人，增人按日计费。保险期限1-3个月的保单不可减人和换人，保险期限超过3个月的保单可以减人或换人，换人规则："
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "替换的人员职业等级需一致，不同职业等级人员之间不可互换；已替换出的人员不允许再次替换或批增。已批减的人员不允许替换或再次批增。已出险人员（含已报案未理赔和已理赔）不可以被替换和批减。线上保全次日生效。"
                            ),
                          ]),
                          _vm._v(
                            "\n            17、如附加《泰康在线财产保险股份有限公司附加伤残赔偿比例调整保险（B款）》保险时，该附加险项下评残标准同样适用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014），按照工伤伤残赔偿标准确定残疾赔偿金，最高以每人伤亡责任限额乘以伤残等级对应的比例为限，伤残等级赔偿限额比例表：一级伤残100%、二级伤残80%、三级伤残70%、四级伤残60%、五级伤残40%、六级伤残30%、七级伤残20%、八级伤残15%、九级伤残7%、十级伤残5%。（如未附加，本条无效）\n            18、如附加《泰康在线财产保险股份有限公司附加行业十级伤残鉴定标准保险》保险时，该附加险项下评残标准同样适用《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014），按照工伤伤残赔偿标\n            准确定残疾赔偿金，最高以每人伤亡责任限额乘以伤残等级对应的比例为限，伤残等级赔偿限额比例表：一级伤残100%、二级伤残90%、三级伤残80%、四级伤残70%、五级伤残60%、六级伤残50%、七级伤残40%、八级伤残30%、九级伤残20%、十级伤残10%。（如未附加，本条无效）\n            19、如附加《泰康在线财产保险股份有限公司附加24小时人身意外伤害扩展保险》保险时，该附加险项下：包含死亡伤残、意外医疗费和误工费保障；每人死亡伤残、医疗费和误工费赔偿限额与主险责任限额相同。该附加险项下意外伤残事故评残标准为人身保险伤残评定标准（行业标准）（中保协发（2013）88号）。（如未附加，本条无效）.\n            20、每日住院津贴保险责任每次事故免赔3天，单次不超90天，累计不超180天，对于雇员的挂床行为，保险人不承担住院津贴给付的保险责任。\n          "
                          ),
                        ]
                      ),
                      _c("el-divider"),
                      _c("h3", [_vm._v("投保声明 ")]),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "line-height": "32px",
                            "white-space": "pre-line",
                          },
                        },
                        [
                          _vm._v("1、"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "本公司已完整阅读并了解以上投保须知及投保险种的保险条款，尤其是对其中免除保险人责任的条款或约定（包括但不限于责任免除、投保人被保险人义务、保险金申请与给付等），本公司已充分理解并接受上述内容，同意以此作为订立保险合同的依据。"
                            ),
                          ]),
                          _vm._v(
                            "\n            2、投保单中所填写的内容均属实，如有隐瞒或不实告知，保险公司有权解除保险合同，对于合同解除前发生的任何事故，保险公司可不承担任何责任。\n            3、保险责任开始后，投保人要求解除保险合同的，自通知保险人之日起，保险合同解除，保险人收取自保险责任开始之日起至合同解除之日止期间的按日比例计收的保险费，并退还剩余部分保险费。\n            4、本公司同意保险公司通过手机（包括手机短信）、E-mail适时提供保险信息服务。\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }